import type { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

type ContainerProps = {
  children: ReactNode;
  className?: string;
};

export const Container = ({ children, className }: ContainerProps) => (
  <div className={clsx(styles.container, className)}>{children}</div>
);
